import styled from 'styled-components';

export const Page = styled.div``;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0;
  padding: 0 16px;
  h1{ color: ${({ theme }) => theme.colors.green[700]}; margin: 0 0 6px; }
  p{ margin: 0; color: ${({ theme }) => theme.colors.gray[600]}; }
`;

export const Images = styled.div`
  max-width: ${({ theme }) => theme.container};
  margin: 16px auto 0; padding: 0 16px;
  display: grid; grid-template-columns: repeat(auto-fit, minmax(240px,1fr)); gap: 10px;
  img{ width: 100%; height: auto; border-radius: 10px; display: block; }
`;

export const Body = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 16px auto 0; padding: 0 16px;
`;
